<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppShell',
}
</script>
